<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="create-ad-discount-modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form @submit.prevent="submit">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>

                        <h4 class="modal-title">
                            Create Ad Discount
                        </h4>
                    </div>

                    <div class="modal-body">
                        <select-form-group
                                v-model="adDiscount.method"
                                name="method"
                                label="Method"
                                :error="getError('method')"
                                :options="[{value: 'percentage', label: 'Percentage'}, {value: 'price', label: 'Price'}]"
                        ></select-form-group>

                        <number-form-group
                                v-model="adDiscount.amount"
                                name="amount"
                                label="Amount"
                                :error="getError('amount')"
                        ></number-form-group>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>

                        <button type="submit" class="btn btn-black">
                            <i class="fa fa-save"></i> Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import notify from '@/notify'
    import Errors from '@/mixins/Errors'
    import NumberFormGroup from '@/vendor/forms/FormGroups/Block/Number'
    import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'

    export default {
        components: {NumberFormGroup, SelectFormGroup},

        mixins: [Errors],

        props: ['ads'],

        data() {
            return {
                adDiscount: {}
            }
        },

        mounted() {
            this.listenForClose()
        },

        computed: {
            url () {
                return '/api/v1/ad-discounts'
            }
        },

        methods: {
            listenForClose() {
                $('#create-ad-discount-modal').on('hidden.bs.modal', this.reset)
            },

            submit() {
                http.post(this.url, {ads: this.ads, ...this.adDiscount})
                    .then(() => {
                        notify.success('The ad discount was saved')

                        this.$emit('created')

                        $('#create-ad-discount-modal').modal('hide')
                    })
                    .catch(this.catchValidationErrors)
            },

            reset() {
                this.errors = {}

                this.adDiscount = {}
            }
        }
    }
</script>
